import type { AiBusinessCenterModule } from '../types'

/** 售后管理独立应用配置。 */
export const aftersaleModule: AiBusinessCenterModule = {
  key: 'aftersale',
  label: '售后管理',
  desc: '报修工单/服务执行/工程师配件/退换货/质保投诉',
  path: '/aftersale',
  homePath: '/aftersale/repair',
  icon: 'ep:tools',
  color: '#f59e0b'
}
